module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/assessment_achievements/2@2x_0e870c592cfa5598790cd2817d617fd4.png";